
  import { KanziWMSEnvironmentModel } from '@kanzi-apes/kanzi-models';
  export const environment: KanziWMSEnvironmentModel = {
    link_desk_help: '',
    environment: 'development',
    template_purchase_orders: '',
    template_dispatch_orders: '',
    template_return_orders: '',
    template_transfer_orders: '',
    template_products: '',
    template_locations: '',
    template_optimal_route: 'https://wms-apeswmsdev-wms-bucket-dev.s3.us-east-1.amazonaws.com/optimal_route/ruta_optima.csv',
    filter_warehouses_user:true,
    production: true,
    bucket_image_storage: '',
    QS_INVENTORY_DASHBOARD_NAME: '',
    cognitoConfig: {
      cognitoUserPoolId: 'us-east-1_JhtdNM1Mz',
      cognitoAppClientId: '6rjrvlp3elvovpu2ps3quqch4d',
      cognitoRegion: '',
      cognitoIdentityPoolId: ''
    },
    qsApiUrlCommon: 'https://apes-qs-embed-api.technoapes.io/',
    tenantId: 'f2056025',
    dataloaderHide: true,
    printOrders: {
      generatePrintFile: true,
      printAgent: true,
      printAgentUrl: 'https://localhost:5001/imprimir',
      defaultPrinterIp: '',
    },
    apiRestModules: {
      kongWMSAPI: {
        locations: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'locations-v1',
        },
        locationsV3: {
          apiURL: 'https://4vkiu3aelj.execute-api.us-east-1.amazonaws.com/dev/',
          apiPath: 'locations-v3',
        },
        userConfigs: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'user-config',
        },
        thirdParties: {
          apiURL: 'https://api-2-apeswmsdev-dev.technoapes.io/',
          apiPath: 'third',
        },
        products: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'products',
        },
        productsV3: {
          apiURL: 'https://sswiidha8e.execute-api.us-east-1.amazonaws.com/dev/',
          apiPath: 'variant-v3',
        },
        stockProduct:{
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'inventory-lines',
        },
        stockProductV3:{
          apiURL: 'https://9q4jhytafc.execute-api.us-east-1.amazonaws.com/dev/',
          apiPath: 'Inventory-lines',
        },
        users: {
          apiURL: 'https://api-2-apeswmsdev-dev.technoapes.io/',
          apiPath: 'users',
        },
        orders: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'dispatch-orders',
        },
        enlistmentOrders: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'enlistment-orders',
        },
        deliveryOrders: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'delivery-orders',
        },
        purchaseOrders: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'purchase-order-v1',
        },
        purchaseOrderLines: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'purchase-orders-v1',
        },        
        receiptsOrders: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'order-receipts',
        },
        returnsOrders: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'return-order',    
        },    
        locationTypes: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'location'         
        },
        reports: {
            apiURL: '',
            apiPath: 'qs/get-embed-url',
        },
        dataLoader: {
          apiURL: '',
          apiPath: 'master-files',
        },
        user_roles: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'user-roles',
        },
        user_creation: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'users-v1',
        },
        userConfigUpdate: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'user-configs',
        },
        inventoryCounts: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'inventory-counts',
        },
        types: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'types',
        },
        locationPriority: {
          apiURL: 'https://api-apeswmsdev-dev.technoapes.io/',
          apiPath: 'location-priority'
        },
        containers: {
          apiURL: 'https://9q4jhytafc.execute-api.us-east-1.amazonaws.com/dev/',
          apiPath: 'api/v1/containers'
        },
        webhooks: {
          apiURL: '',
          apiPath: 'webhooks',
        },
        replenishmentConfigs: {
          apiURL: 'https://9q4jhytafc.execute-api.us-east-1.amazonaws.com/dev/',
          apiPath: 'api/v1/replenishment-configs',
        },
        replenishmentTasks: {
          apiURL: 'https://9q4jhytafc.execute-api.us-east-1.amazonaws.com/dev/',
          apiPath: 'api/v1/replenishment-tasks',
        }
      }
    }}; 